module.exports = __webpack_public_path__ + "img/idCard.32d2a6d9.png";